import { Control, Controller, FieldError, FieldValues, Path } from 'react-hook-form';
import { InputText, InputTextProps } from './InputText';

export interface InputTextPropsWith<T extends FieldValues>
  extends Omit<InputTextProps, 'onChange' | 'value' | 'onBlur'> {
  control: Control<T, object>;
  name: Path<T>;
  error?: FieldError | undefined;
  smallTitle?: boolean;
}

export const TextInputWithControl = <T extends FieldValues>({
  name,
  control,
  error,
  ...rest
}: InputTextPropsWith<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, onChange, value }, formState: { errors } }) => {
        return <InputText onBlur={onBlur} onChange={onChange} value={value} error={error} {...rest} />;
      }}
    />
  );
};
